<script setup lang="ts">
import { Slot } from 'radix-vue'
import { cn } from '../utils'

defineProps<{
    id: string
    suffix: string | null
}>()
</script>

<template>
    <div class="relative rounded-md shadow-xs">
        <Slot
            :class="
                cn({
                    'pr-12': suffix,
                })
            "
        >
            <slot />
        </Slot>
        <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
            v-if="suffix"
        >
            <span class="text-gray-500 sm:text-sm" :id="`${id}-description`">
                {{ suffix }}
            </span>
        </div>
    </div>
</template>
